(function() {
  angular.module('cfn').factory('CropSequence', CropSequence);

  CropSequence.$inject = ['dataSource.factory'];

  function CropSequence(dataSource) {
    return dataSource('cropSequence').getRestService();
  }
})();
